import { AppModule } from 'app/module';
import './styles.scss';

export class CompanyRecruiter extends AppModule {
    domBindings() {
        return {
            inner: '.m-companyRecruiter__inner',
            inquiryButton: '.m-companyRecruiter__inquiryButton',
            avatarFallBackContainer: '.m-companyRecruiter__avatarContainer',
            avatar: '.m-companyRecruiter__avatar',
            name: '.m-companyRecruiter__name',
            position: '.m-companyRecruiter__position',
        };
    }

    getPropsFromDom() {
        return {
            slug: this.dom.inner ? this.dom.inner.getAttribute('data-slug') : false,
            recruiterEmail: this.dom.inquiryButton
                ? this.dom.inquiryButton.getAttribute('data-recruiter-email') : false,
            userEmail: this.dom.inquiryButton ? this.dom.inquiryButton.getAttribute('data-user-email') : false,
            userFirstName: this.dom.inquiryButton ? this.dom.inquiryButton.getAttribute('data-user-firstname') : false,
            userSurName: this.dom.inquiryButton ? this.dom.inquiryButton.getAttribute('data-user-surname') : false,
            position: this.dom.position ? this.dom.position.innerText : '',
            imgSrc: this.dom.avatar ? this.dom.avatar.src : false,
            male: this.dom.avatarFallBackContainer
                ? (this.dom.avatarFallBackContainer.getAttribute('data-male') === 'true') : false,
            name: this.dom.name ? this.dom.name.innerHTML : false,
        };
    }

    domEvents() {
        if (this.dom.inquiryButton) {
            this.dom.inquiryButton.addEventListener('click', () => this.openInquiryModal());
        }
    }

    openInquiryModal() {
        this.events.emit('openInquiryModal', this.props);
    }
}
